module.exports = __webpack_public_path__ + "img/r2_longhunbarete.fbe1e14d.jpg";